import { render } from "./createProjectDialog.vue?vue&type=template&id=72a5b5f2&scoped=true"
import script from "./createProjectDialog.vue?vue&type=script&lang=js"
export * from "./createProjectDialog.vue?vue&type=script&lang=js"

import "./createProjectDialog.vue?vue&type=style&index=0&id=72a5b5f2&lang=less"
import "./createProjectDialog.vue?vue&type=style&index=1&id=72a5b5f2&lang=less&scoped=true"

import exportComponent from "/Users/xiaobiaoza/Desktop/workspace/GIM/WPP/wpp-aigc-aigc-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a5b5f2"],['__file',"src/layouts/basic-layout/header-account/components/createProjectDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72a5b5f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72a5b5f2', __exports__)) {
    console.log('reload')
    api.reload('72a5b5f2', __exports__)
  }
  
  module.hot.accept("./createProjectDialog.vue?vue&type=template&id=72a5b5f2&scoped=true", () => {
    console.log('re-render')
    api.rerender('72a5b5f2', render)
  })

}


export default __exports__